/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropOptInBody
 */
export interface DropOptInBody {
    /**
     * Self-declared country. Captured, never gating — everyone participates.
     * @type {string}
     * @memberof DropOptInBody
     */
    declaredCountry?: string;
    /**
     * Self-declared U.S. state code.
     * @type {string}
     * @memberof DropOptInBody
     */
    declaredState?: string;
    /**
     * The terms version the member accepted. Optional — the server stamps its own current version; a version that disagrees with it is refused.
     * @type {string}
     * @memberof DropOptInBody
     */
    termsVersion?: string;
}

/**
 * Check if a given object implements the DropOptInBody interface.
 */
export function instanceOfDropOptInBody(value: object): value is DropOptInBody {
    return true;
}

export function DropOptInBodyFromJSON(json: any): DropOptInBody {
    return DropOptInBodyFromJSONTyped(json, false);
}

export function DropOptInBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropOptInBody {
    if (json == null) {
        return json;
    }
    return {
        
        'declaredCountry': json['declaredCountry'] == null ? undefined : json['declaredCountry'],
        'declaredState': json['declaredState'] == null ? undefined : json['declaredState'],
        'termsVersion': json['termsVersion'] == null ? undefined : json['termsVersion'],
    };
}

export function DropOptInBodyToJSON(json: any): DropOptInBody {
    return DropOptInBodyToJSONTyped(json, false);
}

export function DropOptInBodyToJSONTyped(value?: DropOptInBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'declaredCountry': value['declaredCountry'],
        'declaredState': value['declaredState'],
        'termsVersion': value['termsVersion'],
    };
}

